<template>
  <v-dialog
    v-model="show"
    scrollable
    persistent
    :overlay="false"
    min-width="500px"
  >
    <v-card>
      <v-toolbar dark color="#E3002C" class="d-flex align-center">
        <v-btn icon dark @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Relevamiento</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-if="object">
        <v-select
          :disabled="mode === 'edit'"
          :items="cropItems"
          item-text="description"
          item-value="url"
          label="Cultivo"
          v-model="object.crop"
          @change="cropChange($event)"
        ></v-select>
        <v-select
          :disabled="mode === 'edit'"
          :items="campaignItems"
          item-text="code"
          item-value="url"
          label="Campaña"
          v-model="object.campaign"
          @change="campaignChange($event)"
        ></v-select>
        <v-text-field
          label="Hectáreas"
          id="hectares"
          v-model="object.hectare"
          type="number"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="warning" class="ma-2" outlined @click="onClose">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" class="ma-2" outlined @click="save">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DataSurvey from "@/components/clon/DataSurvey.js";

export default {
  name: "SurveyCapaignEdit",

  props: {
    show: {
      type: Boolean,
      default: false
    },
    currentSurvey: {
      type: Object,
      default: function() {
        return {};
      }
    },
    currentSurveyCampaign: {
      type: Object,
      default: function() {
        return {};
      }
    },
    cropItems: {
      type: Array,
      default: function() {
        return [];
      }
    },
    initialMode: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      mode: null,
      campaignItems: null,
      survey: new DataSurvey(this.$bRoot),
      object: null
    };
  },

  methods: {
    onClose() {
      this.$emit("cancel");
    },

    onItemSelected(item) {
      this.$emit("itemSelected", item);
    },

    cropChange(crop) {
      if (!this.object.url) {
        let index = this.cropItems.findIndex(item => item.url === crop);
        this.object.crop = this.cropItems[index].url;
        this.object.crop_id = this.cropItems[index].id;
        this.object.crop_description = this.cropItems[index].description;
        this.pkChange();
      }
    },
    campaignChange(campaign) {
      if (!this.object.url) {
        let index = this.campaignItems.findIndex(item => item.url === campaign);
        this.object.campaign = this.campaignItems[index].url;
        this.object.campaign_id = this.campaignItems[index].id;
        this.object.campaign_code = this.campaignItems[index].code;
        this.object.campaign_current = this.campaignItems[index].current;
        this.pkChange();
      }
    },

    async pkChange() {
      if (!this.object.url && this.object.crop && this.object.campaign) {
        let filterstring =
          "survey__id=" +
          this.object.survey_id.toString() +
          "&campaign__id=" +
          this.object.campaign_id.toString() +
          "&crop__id=" +
          this.object.crop_id.toString();

        let response = await this.$bRoot.search(
          "/data/survey_campaigns",
          null,
          null,
          filterstring,
          1
        );
        if (response.data.results.length > 0) {
          this.object.url = response.data.results[0].url;
          this.object.hectare = response.data.results[0].hectare;
          this.mode = "edit";
        }
      }
    },

    async save() {
      let added = await this.survey.campaignSave(this.currentSurveyCampaign);
      if (added) {
        this.$emit("saved");
      }
    }
  },

  async mounted() {
    let campaigns = await this.$bRoot.search(
      "/data/campaigns",
      null,
      "-code",
      "current=True"
    );
    this.campaignItems = campaigns.data.results;

    this.object = this.currentSurveyCampaign;
    this.mode = this.initialMode;

    if (!this.object.url) {
      this.pkChange();
    }
  }
};
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
